import { put, call, takeLatest } from 'redux-saga/effects';

import { routines } from '../../reducers/db/user';
import userApi from '../../services/user';

function* getCurrentUser() {
  try {
    const currentUser = yield call(userApi.currentUser);
    const loggedInUser = yield call(userApi.loggedInUser);
    yield put(
      routines.getCurrentUser.success({
        currentUser,
        loggedInUser
      })
    );
  } catch (error) {
    yield put(routines.getCurrentUser.failure(error));
  }
}

function* getUsers() {
  try {
    const user = yield call(userApi.getUsers);
    yield put(routines.getUsers.success(user));
  } catch (error) {
    yield put(routines.getUsers.failure(error));
  }
}

export default function* userSaga() {
  yield takeLatest(routines.getCurrentUser.TRIGGER, getCurrentUser);
  yield takeLatest(routines.getUsers.TRIGGER, getUsers);
}
